import {SimplePresentation, SimplePresentationRunnerController} from "../../../SimplePresentationRunner";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../../../XwaysHoarder2";
import {BasicSymbol, SymbolStates} from "../../../reels/symbols/BasicSymbol";
import {XwaysHoarder2Statics} from "../../../XwaysHoarder2Statics";
import {ScatterSymbol} from "../../../reels/symbols/ScatterSymbol";
import {XwaysHoarder2GameAssets} from "../../../XwaysHoarder2GameAssets";
import {SpineGSAPWrapper} from "../../../utils/SpineGSAPWrapper";
import {XwaysHoarder2Sound} from "../../../sound/XwaysHoarder2Sound";


export class SCCToXSplitBeforeSFS implements SimplePresentation {
    name: string = "SSCToXSplitBe4SFS";
    private _convnTl: gsap.core.Timeline;
    private allSSCPos: number[][] = [];
    private allSSCSpines: PIXI.spine.Spine[] = [];

    shouldRun(): boolean {
        return XwaysHoarder2.model.isSuperFreespinStarting;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._convnTl = gsap.timeline({
            onComplete: () => {
                controller.setSkipCallback();
                controller.finish();
            }
        });
        this.allSSCPos = [];
        this.allSSCSpines = [];

        XwaysHoarder2.screenInteractive.setInteractiveState(true);
        XwaysHoarder2.screenInteractive.clickArea.on('pointerdown', () => {
            XwaysHoarder2.screenInteractive.setInteractiveState(false);
            this.onReverseSkip();
            if (XwaysHoarder2Sound.soundPlayer.fetchSoundPlayer(XwaysHoarder2Sound.SCATTER_XSPLIT)?.isPlaying) {
                XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.SCATTER_XSPLIT);
            }
        });


        [1, 2, 3, 4].forEach((reelNo: number) => {
            [0, 1, 2].forEach((symNo: number) => {
                const checkSymData: BasicSymbol = <BasicSymbol>XwaysHoarder2.reelView.reels[reelNo].model.getVisibleSymbolAt(symNo).positionable;
                if (checkSymData.symbolName === "SSC") {
                    const currentSSCTl: gsap.core.Timeline = gsap.timeline();
                    let currentSYmIndex: number = JSON.parse(JSON.stringify(symNo));
                    this.allSSCPos.push([reelNo, symNo]);
                    if (currentSYmIndex + 1 < 3) {
                        currentSSCTl.add(this.checkNextSymForConversion(<ScatterSymbol>checkSymData, reelNo, symNo));
                    }
                    this._convnTl.add(currentSSCTl, 0);

                }
            });
        });
        this._convnTl.add(this._convnTl.addLabel("postSSCNudge"), ">");


        //transformation anim
        const transformTl: gsap.core.Timeline = gsap.timeline();
        let sscToXsSoundPlayed: boolean = false;
        this.allSSCSpines.forEach((item: PIXI.spine.Spine) => {
            transformTl.add(SpineGSAPWrapper.createTimelineForAnimation(item, 0, "SSC Transform", false), 0);
            if(!sscToXsSoundPlayed) {
                transformTl.add(() => {XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.SCATTER_XSPLIT);}, "<");
                sscToXsSoundPlayed = true;
            }
        });

        this.allSSCPos.forEach((pos: number[]) => {
            const checkSymData: BasicSymbol = <BasicSymbol>XwaysHoarder2.reelView.reels[pos[0]].model.getVisibleSymbolAt(pos[1]).positionable;
            if (checkSymData.symbolName === "SSC") {
                transformTl.add(() => {
                    const sscSYm: ScatterSymbol = <ScatterSymbol>checkSymData;
                    sscSYm.getStateAnimation(SymbolStates.REVEAL);
                }, 0);
                if(!sscToXsSoundPlayed) {
                    transformTl.add(() => {XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.SCATTER_XSPLIT);}, "<");
                    sscToXsSoundPlayed = true;
                }
            }
            transformTl.add(() => {
                XwaysHoarder2.reelView.reels[pos[0]].replaceSymOnReel(pos[1], "XS", true, SymbolStates.NORMAL, "_revealed");
               // const newXSSym: XSplitSymbol = <XSplitSymbol>XwaysHoarder2.reelView.reels[pos[0]].model.getVisibleSymbolAt(pos[1]).positionable;
                //  newXSSym.getStateAnimation(SymbolStates.STICKY)
                //XwaysHoarder2.reelView.reels[pos[0]].lockSpecialSymAndAddDummyBelow(pos[1], "D", true);
            }, 1);

        });
        this.allSSCSpines.forEach((item: PIXI.spine.Spine) => {
            transformTl.add(() => {
                item.destroy();
            }, 1);
        });
        this._convnTl.add(transformTl, "postSSCNudge");
        this._convnTl.to(this, {duration: 0.2});

    }

    private onReverseSkip(): void {
        this._convnTl.totalProgress(1);
    }

    private checkNextSymForConversion(currentSym: ScatterSymbol, currentReel: number, currentIndex: number): gsap.core.Timeline {
        const nextTl: gsap.core.Timeline = gsap.timeline();
        const nextIndex: number = currentIndex + 1;
        // const checkNextSym: BasicSymbol = <BasicSymbol>XwaysHoarder2.reelView.reels[currentReel].model.getVisibleSymbolAt(nextIndex).positionable;
        if (XwaysHoarder2.model.isSuperFreespinStarting) {
            nextTl.add(this.playTransformAnim(currentSym, currentReel, nextIndex), 0);
        }
        return nextTl;
    }

    private playTransformAnim(mainSym: ScatterSymbol, mainReel: number, nxtIndex: number): gsap.core.Timeline {
        const nudgeTl: gsap.core.Timeline = gsap.timeline();
        const sscCopy: PIXI.spine.Spine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.SCATTER));
        sscCopy.alpha = 0;
        sscCopy.state.setAnimation(0, "SSC Idle", false);
        sscCopy.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5 + mainSym.symID * 200);
        XwaysHoarder2.reelView.reels[mainReel].layers.lockOverlay.addChild(sscCopy);
        nudgeTl.to(sscCopy, {alpha: 1, duration: 0.2}, 0);
        nudgeTl.to(sscCopy.scale, {x: 1.2, y: 1.2, duration: 0.2}, 0);
        nudgeTl.to(sscCopy.position, {y: sscCopy.position.y + 200, duration: 0.2});

        nudgeTl.to(sscCopy.scale, {x: 1, y: 1, duration: 0.2}, ">");
        nudgeTl.to((<BasicSymbol>XwaysHoarder2.reelView.reels[mainReel].model.getVisibleSymbolAt(nxtIndex).positionable).view, {
            alpha: 0,
            duration: 0.2
        }, "<");
        /*    nudgeTl.to(sscCopy, {alpha: 0, duration: 0.3}, "<");
            nudgeTl.add(() => {
                XwaysHoarder2.reelView.reels[mainReel].layers.lockOverlay.removeChild(sscCopy)
            }, ">");*/
        this.allSSCSpines.push(sscCopy);
        this.allSSCPos.push([mainReel, nxtIndex]);
        if (nxtIndex + 1 < 3) {
            nudgeTl.add(this.checkNextSymForConversion(<ScatterSymbol>XwaysHoarder2.reelView.reels[mainReel].model.getVisibleSymbolAt(nxtIndex).positionable, mainReel, nxtIndex), ">");
        }
        return nudgeTl;
    }
}